"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var update_delivery_data_1 = require("../../api/calls/basket/update_delivery_data");
var all_branches_1 = require("../../api/calls/client/all_branches");
var nearest_branches_1 = require("../../api/calls/client/nearest_branches");
var pay_with_payfast_1 = require("../../api/calls/payment-engine/pay_with_payfast");
var address_list_1 = require("../../api/calls/user/address_list");
var add_user_address_1 = require("../../api/calls/user/add_user_address");
var basket_1 = require("../../reducers/slices/basket/basket");
var main_1 = require("../../reducers/slices/main");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var get_basket_thunk_1 = require("../../reducers/slices/basket/thunks/get_basket_thunk");
var payfast_png_1 = __importDefault(require("../../assets/payfast.png"));
var set_checkout_cookie_thunk_1 = require("../../reducers/slices/basket/thunks/set_checkout_cookie_thunk");
var CheckoutPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var cookie = new universal_cookie_1.default();
    var basket = (0, react_redux_1.useSelector)(function (state) { return state.basketState; }).basket;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _k = (0, react_1.useState)(null), selectedBranch = _k[0], setSelectedBranch = _k[1];
    var _l = (0, react_1.useState)(false), saveAddress = _l[0], setSaveAddress = _l[1];
    var _m = (0, react_1.useState)(null), selectedAddress = _m[0], setSelectedAddress = _m[1];
    var _o = (0, react_1.useState)(""), newAddressLabel = _o[0], setNewAddressLabel = _o[1];
    var _p = (0, react_1.useState)(""), newAddressErrorText = _p[0], setNewAddressErrorText = _p[1];
    var _q = (0, react_1.useState)(0), currentStep = _q[0], setCurrentStep = _q[1];
    var _r = (0, react_1.useState)(""), deliveryOrCollection = _r[0], setDeliveryOrCollection = _r[1];
    var _s = (0, react_1.useState)([]), addressList = _s[0], setAddressList = _s[1];
    var _t = (0, react_1.useState)(false), isAddingAddress = _t[0], setIsAddingAddress = _t[1];
    var _u = (0, react_1.useState)(""), specialInstructions = _u[0], setSpecialInstructions = _u[1];
    var _v = (0, react_1.useState)(false), isGettingBranches = _v[0], setIsGettingBranches = _v[1];
    var _w = (0, react_1.useState)(null), formData = _w[0], setFormData = _w[1];
    var payFastFormRef = (0, react_1.useRef)();
    var _x = (0, react_1.useState)(false), payFastLoading = _x[0], setPayFastLoading = _x[1];
    // // console.log("generateSignature", );
    (0, react_1.useEffect)(function () {
        var _a;
        if (!basket) {
            navigate("/shop");
        }
        else {
            // console.log("user.user._id", user.user._id);
            dispatch((0, basket_1.setDeliveryMethod)(null));
            (0, address_list_1.address_list)({
                user_id: (_a = user.user._id) !== null && _a !== void 0 ? _a : "",
            }).then(function (response) {
                if (response.success) {
                    setAddressList(response.content.addresses);
                }
                else {
                    dispatch((0, main_1.setMainModal)({
                        title: "Something went wrong!",
                        messages: [response.message],
                    }));
                }
            });
            // pay_with_payfast({
            //   integration_id: user.user._id ?? "",
            //   return_url: "https://ackermans-pharmacy-web-dev-pdstjj77fq-ew.a.run.app/#/return_url",
            //   cancel_url: "https://ackermans-pharmacy-web-dev-pdstjj77fq-ew.a.run.app/#/cancel_url",
            //   name_first: user.user.name,
            //   name_last: user.user.surname,
            //   cell_number: user.user.cell_number,sas
            //   amount: "13.00",
            //   item_name: "Test Product",
            // }).then((response) => {
            //   if (response.success) {
            //     setFormData(response.content);
            //   } else {
            //     dispatch(setMainModal({ title: "Could not generate PayFast form!", messages: [response.message] }));
            //   }
            // });
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (selectedAddress) {
            setIsGettingBranches(true);
            (0, nearest_branches_1.nearest_branches)({
                order_type: deliveryOrCollection,
                size: "10",
                center_coordinates: {
                    longitude: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude,
                    latitude: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude,
                },
            }).then(function (response) {
                var _a;
                setIsGettingBranches(false);
                if (response.success) {
                    setSelectedBranch((_a = response.content[0]) !== null && _a !== void 0 ? _a : null);
                }
                else {
                    dispatch((0, main_1.setMainModal)({
                        title: "Could not get nearest branches!",
                        messages: [response.message],
                    }));
                }
            });
        }
    }, [selectedAddress]);
    (0, react_1.useEffect)(function () {
        if (formData) {
            dispatch((0, set_checkout_cookie_thunk_1.set_checkout_cookie_thunk)());
            payFastFormRef.current.submit();
        }
    }, [formData]);
    (0, react_1.useEffect)(function () {
        if (deliveryOrCollection == "collection") {
            setIsGettingBranches(true);
            (0, all_branches_1.all_branches)().then(function (response) {
                var _a, _b;
                setIsGettingBranches(false);
                if (response.success) {
                    // console.log("all_branches", response.content);
                    setSelectedBranch({
                        branch: (_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a.branch_list[0]) !== null && _b !== void 0 ? _b : null,
                    });
                }
                else {
                    dispatch((0, main_1.setMainModal)({
                        title: "Could not get all branches!",
                        messages: [response.message],
                    }));
                }
            });
        }
        else {
            setSelectedBranch(null);
        }
    }, [deliveryOrCollection]);
    var onNext = function () {
        var nextStep = currentStep + 1;
        if (nextStep < customSteps.length) {
            setCurrentStep(nextStep);
        }
    };
    var onPrevious = function () {
        var nextStep = currentStep - 1;
        if (currentStep > 0) {
            setCurrentStep(nextStep);
        }
    };
    var validateDeliveryMethod = function () {
        var messages = [];
        if (!deliveryOrCollection) {
            messages.push("Please select a delivery method.");
        }
        else {
            if (deliveryOrCollection == "collection") {
                if (!selectedBranch || !selectedBranch.branch) {
                    messages.push("Unfortunately, we were unable to retrieve branches, please contact support.");
                }
            }
        }
        if (messages.length > 0) {
            dispatch((0, main_1.setMainModal)({ title: "Delivery method needed", messages: messages }));
            return false;
        }
        else {
            return true;
        }
    };
    var validateAddress = function () {
        var messages = [];
        var errorCount = 0;
        if (!selectedAddress) {
            messages.push("Please select an address, or add a new address in order to continue.");
        }
        if (!selectedBranch) {
            messages.push("Unfortunately, we do not deliver to this address. Please select a different address, or choose to collect.");
        }
        if (saveAddress && !newAddressLabel) {
            errorCount++;
            setNewAddressErrorText("Please enter a label for your new address.");
        }
        if (messages.length > 0 || errorCount > 0) {
            if (messages.length > 0) {
                dispatch((0, main_1.setMainModal)({ title: "Address selection needed!", messages: messages }));
            }
            return false;
        }
        else {
            return true;
        }
    };
    var customSteps = [
        {
            label: "Choose Delivery or Collection",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.RadioButtonsControl, { title: "Delivery Method", radioIconColor: "text-primary", selectedValue: deliveryOrCollection, options: [
                        { label: "Delivery", value: "delivery" },
                        { label: "Collection", value: "collection" },
                    ], onChange: function (value) {
                        setDeliveryOrCollection(value);
                    } }),
                react_1.default.createElement("div", { className: "flex flex-row" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", loading: isGettingBranches, onClick: function () {
                            if (validateDeliveryMethod()) {
                                dispatch((0, basket_1.setDeliveryMethod)(deliveryOrCollection));
                                onNext();
                            }
                            // setIsAddingAddress(false);
                        } })))),
        },
        {
            // hidden: deliveryOrCollection == "collection",
            label: "Select Address",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                isAddingAddress ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { value: selectedAddress, required: true, label: "Search Address", size: "medium", onSelectionChange: function (addressObject) {
                            if (addressObject) {
                                setSelectedAddress({
                                    full_address: addressObject.fullAddress,
                                    longitude: addressObject.coordinates.lng.toString(),
                                    latitude: addressObject.coordinates.lat.toString(),
                                });
                            }
                        } }),
                    selectedAddress && (react_1.default.createElement("div", { className: "flex flex-col rounded-lg border border-primary" },
                        react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center p-2 pl-4" },
                            react_1.default.createElement("div", { className: "flex-1" }, selectedAddress.full_address),
                            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Save this address?", value: saveAddress, onChange: function (v) {
                                    setSaveAddress(v);
                                } })),
                        saveAddress && (react_1.default.createElement("div", { className: "px-2 pb-2" },
                            react_1.default.createElement("div", { className: "w-1/2" },
                                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Name this address", size: "small", errorText: newAddressErrorText, value: newAddressLabel, onChange: function (v) {
                                        setNewAddressLabel(v);
                                    } })))))))) : (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", null, addressList && addressList.length > 0 ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" }, addressList.map(function (address, index) {
                        return (react_1.default.createElement("div", { key: index, className: "p-4 border border-gray-400 rounded-md cursor-pointer", onClick: function () {
                                setSelectedAddress({
                                    full_address: address.full_address,
                                    longitude: address.longitude,
                                    latitude: address.latitude,
                                });
                                // onNext();
                            } },
                            react_1.default.createElement("div", { className: "flex flex-row items-center" },
                                react_1.default.createElement("div", { className: "flex flex-col flex-1" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: address.label, className: "cursor-pointer" //
                                        , textColor: "text-secondary" }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: address.full_address, className: "cursor-pointer" //
                                        , textColor: "text-secondary", size: "xsmall" })),
                                address.full_address == (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address) && (react_1.default.createElement("div", { className: "rounded-lg bg-primary px-2 py-1 flex flex-row items-center" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "SELECTED", className: "cursor-pointer" //
                                        , textColor: "text-white", size: "xsmall" }))))));
                    }))) : (react_1.default.createElement("div", null,
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You don't have any saved addresses. Please add an address." })))))),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", loading: isGettingBranches, onClick: function () {
                            var _a, _b, _c, _d, _e, _f, _g;
                            if (validateAddress()) {
                                if (saveAddress) {
                                    (0, add_user_address_1.add_user_address)({
                                        _id: (_a = user === null || user === void 0 ? void 0 : user.user._id) !== null && _a !== void 0 ? _a : "",
                                        label: newAddressLabel,
                                        full_address: selectedAddress.full_address,
                                        latitude: (_b = selectedAddress.latitude) === null || _b === void 0 ? void 0 : _b.toString(),
                                        longitude: (_c = selectedAddress.longitude) === null || _c === void 0 ? void 0 : _c.toString(),
                                    }).then(function (response) {
                                        if (response.success) {
                                            setAddressList(__spreadArray([], addressList, true));
                                        }
                                        else {
                                            dispatch((0, main_1.setMainModal)({
                                                title: "Could not save user address.",
                                                messages: [response.message],
                                            }));
                                        }
                                    });
                                }
                                (0, update_delivery_data_1.update_delivery_data)({
                                    _id: (_d = basket === null || basket === void 0 ? void 0 : basket._id) !== null && _d !== void 0 ? _d : "",
                                    basket: {
                                        type: deliveryOrCollection,
                                        provider: basket.provider,
                                        branch_id: (_e = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) === null || _e === void 0 ? void 0 : _e._id,
                                        address: {
                                            full_address: selectedAddress.full_address,
                                            latitude: (_f = selectedAddress.latitude) === null || _f === void 0 ? void 0 : _f.toString(),
                                            longitude: (_g = selectedAddress.longitude) === null || _g === void 0 ? void 0 : _g.toString(),
                                        },
                                    },
                                }).then(function (response) {
                                    if (response.success) {
                                        dispatch((0, get_basket_thunk_1.get_basket_thunk)());
                                    }
                                });
                                onNext();
                            }
                        } }),
                    isAddingAddress ? (react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Show address list", size: "small", onClick: function () {
                            setSelectedAddress(null);
                            setIsAddingAddress(false);
                        } })) : (react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Add address", size: "small", onClick: function () {
                            setSelectedAddress(null);
                            setIsAddingAddress(true);
                        } })),
                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            hidden: deliveryOrCollection == "collection",
            label: "Special Instructions",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex flex-col" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Optionally provide any special instructions." }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "For example: \"Hoot at gate.\"", size: "xsmall" })),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Special Instructions", lines: 4, size: "small", borderColor: "border-gray-400", value: specialInstructions, onChange: function (v) {
                        setSpecialInstructions(v);
                    } }),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", onClick: function () {
                            var _a, _b, _c, _d;
                            (0, update_delivery_data_1.update_delivery_data)({
                                _id: (_a = basket === null || basket === void 0 ? void 0 : basket._id) !== null && _a !== void 0 ? _a : "",
                                basket: {
                                    type: deliveryOrCollection,
                                    provider: basket.provider,
                                    branch_id: (_b = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) === null || _b === void 0 ? void 0 : _b._id,
                                    address: {
                                        full_address: selectedAddress.full_address,
                                        latitude: (_c = selectedAddress.latitude) === null || _c === void 0 ? void 0 : _c.toString(),
                                        longitude: (_d = selectedAddress.longitude) === null || _d === void 0 ? void 0 : _d.toString(),
                                    },
                                },
                            }).then(function (response) {
                                if (response.success) {
                                    dispatch((0, get_basket_thunk_1.get_basket_thunk)());
                                }
                            });
                            onNext();
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            label: "Payment Method",
            component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                formData && (react_1.default.createElement("form", { ref: payFastFormRef, action: process.env.PAYFAST_FORM_URL, method: "post" //
                    , className: "hidden" }, Object.keys(formData).map(function (key, index) {
                    return react_1.default.createElement("input", { key: "form-hidden-field-".concat(index), type: "hidden", name: key, value: formData[key] });
                }))),
                react_1.default.createElement(doshx_controls_web_1.BoxControl, { addPadding: false }, payFastLoading ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" })) : (react_1.default.createElement("img", { src: payfast_png_1.default, className: "h-[50px] object-cover border-borders-dark", alt: "payment_via_payfast", onClick: function () {
                        var _a;
                        setPayFastLoading(true);
                        var url = process.env.PAYFAST_REDIRECT_URL;
                        (0, pay_with_payfast_1.pay_with_payfast)({
                            integration_id: (_a = user.user._id) !== null && _a !== void 0 ? _a : "",
                            return_url: "".concat(url, "/#/outcome/success"),
                            cancel_url: "".concat(url, "/#/outcome/cancelled"),
                            name_first: user.user.name,
                            name_last: user.user.surname,
                            cell_number: user.user.cell_number,
                            amount: parseFloat(basket === null || basket === void 0 ? void 0 : basket.outstanding_amount).toFixed(2),
                            item_name: "".concat(process.env.APP_NAME, " Shopping Basket"),
                        }).then(function (response) {
                            var _a;
                            setPayFastLoading(false);
                            if (response.success) {
                                // dispatch(setPaymentIdentifiers(response.content.m_payment_id));
                                setFormData((_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.result);
                            }
                            else {
                                dispatch((0, main_1.setMainModal)({
                                    title: "Could not generate PayFast form!",
                                    messages: [response.message],
                                }));
                            }
                        });
                    } }))),
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                        onPrevious();
                    } }))),
        },
    ];
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col lg:flex-row lg:items-start gap-4" },
            react_1.default.createElement("div", { className: "flex-grow" },
                react_1.default.createElement(doshx_controls_web_1.StepperControl, { stepPillBackgroundColor: "bg-primary", lineColor: "border-primary", currentStep: currentStep, 
                    // onNextClick={(step) => {
                    //   // console.log("next", step);
                    // }}
                    // onPreviousClick={(step) => {
                    //   // console.log("previous", step);
                    // }}
                    steps: customSteps })),
            react_1.default.createElement("div", { className: "lg:w-fit" },
                react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "flex-none flex flex-col" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Order Summary", textColor: "text-secondary", size: "large", bold: true }),
                        selectedBranch &&
                            (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) && ( //TODO we need to check if the branch is selected and that it is not NULL when ew press "Next"
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                            react_1.default.createElement("div", { className: "flex flex-row items-center" },
                                react_1.default.createElement("div", { className: "flex-1" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_a = selectedBranch.branch.display_name) !== null && _a !== void 0 ? _a : "", size: "small", textColor: "text-secondary" })),
                                react_1.default.createElement("div", { className: "py-1 px-2 bg-primary rounded-lg flex flex-row items-center" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: deliveryOrCollection == "delivery" ? "".concat(selectedBranch.distance, "km") : "Collection", size: "xsmall", textColor: "text-white" }))))),
                        react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                        react_1.default.createElement("div", null, basket &&
                            basket.product_list.map(function (product, index) {
                                var _a, _b, _c, _d;
                                return (react_1.default.createElement("div", { key: index, className: "flex flex-row justify-between items-center" },
                                    react_1.default.createElement("div", { className: "pr-4 pb-[2px]" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat(product.title, " x ").concat(product.quantity), textColor: "text-secondary" })),
                                    !product.on_promotion ? (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                            value: (_b = (_a = product.price) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "0",
                                        }), textColor: "text-secondary" })) : (react_1.default.createElement("div", { className: "flex items-center justify-between gap-4" },
                                        react_1.default.createElement("div", { className: "line-through" },
                                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                                    value: (_c = product === null || product === void 0 ? void 0 : product.price) !== null && _c !== void 0 ? _c : "0",
                                                    decimalPlaces: 2,
                                                }), size: "xsmall" })),
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                                value: (_d = product === null || product === void 0 ? void 0 : product.promotion_price) !== null && _d !== void 0 ? _d : "0",
                                                decimalPlaces: 2,
                                            }), 
                                            // size="small"
                                            textColor: "text-primary" })))));
                            }))),
                    react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Subtotal", textColor: "text-secondary" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                    value: (_b = basket === null || basket === void 0 ? void 0 : basket.sub_total.toString()) !== null && _b !== void 0 ? _b : "0",
                                    decimalPlaces: 2,
                                }), textColor: "text-secondary" })),
                        react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "VAT", textColor: "text-secondary" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                    value: (_c = basket === null || basket === void 0 ? void 0 : basket.vat.toString()) !== null && _c !== void 0 ? _c : "0",
                                    decimalPlaces: 2,
                                }), textColor: "text-secondary" })),
                        deliveryOrCollection == "delivery" && !(basket === null || basket === void 0 ? void 0 : basket.has_delivery_fee_deal) && (react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Delivery", textColor: "text-secondary" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                    value: (_d = basket === null || basket === void 0 ? void 0 : basket.delivery_fee) !== null && _d !== void 0 ? _d : "0",
                                    decimalPlaces: 2,
                                }), textColor: "text-secondary" }))),
                        deliveryOrCollection == "delivery" && basket.has_delivery_fee_deal && (react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Delivery", textColor: "text-secondary" }),
                            react_1.default.createElement("div", { className: "line-through", color: "text-primary" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                        value: (_e = basket === null || basket === void 0 ? void 0 : basket.delivery_fee) !== null && _e !== void 0 ? _e : "0",
                                        decimalPlaces: 2,
                                    }) })),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                    value: (_f = basket === null || basket === void 0 ? void 0 : basket.delivery_fee_deal) !== null && _f !== void 0 ? _f : "0",
                                    decimalPlaces: 2,
                                }), textColor: "text-secondary" })))),
                    react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                    react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Order Total", textColor: "text-secondary" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                value: parseFloat((_g = basket === null || basket === void 0 ? void 0 : basket.total.toString()) !== null && _g !== void 0 ? _g : "0").toString(),
                                decimalPlaces: 2,
                            }), textColor: "text-secondary" })),
                    react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Discount Total", textColor: "text-secondary" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                value: parseFloat((_h = basket === null || basket === void 0 ? void 0 : basket.total_product_deals.toString()) !== null && _h !== void 0 ? _h : "0").toString(),
                                decimalPlaces: 2,
                            }), textColor: "text-secondary" })),
                    react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                    react_1.default.createElement("div", { className: "flex flex-row justify-between gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Outstanding Amount", textColor: "text-primary", size: "large", bold: true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                value: parseFloat((_j = basket === null || basket === void 0 ? void 0 : basket.outstanding_amount.toString()) !== null && _j !== void 0 ? _j : "0").toString(),
                                decimalPlaces: 2,
                            }), textColor: "text-primary", size: "large", bold: true }))))),
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" })));
};
exports.CheckoutPage = CheckoutPage;
